<template>
	<div class="content">
		<headerTop></headerTop>
		<div class="swiperImg" :style="{backgroundImage:'url('+$index.addurl(detail.background_img)+')'}"></div>
		<!-- 办公环境 -->
		<div class="center page-content flexbetween" :style="{animation:animation}">
			<div class="right">
				<div class="child" v-html="detail.content"> </div>
			</div>
		</div>
	</div>
</template>

<script>
	import router from "../../router";
	import headerTop from '../../components/headerTop.vue'
	export default {
		components: {
			headerTop
		},
		data() {
			return {
				value: false, //分页只有一页时隐藏分页
				currentPage: 1, //分页当前页数
				id: 0,
				contents: '',
				img: '',
				animation: '',
				detail: {},
			}
		},
		created() {
			this.animation = 'detail .4s linear forwards'
			this.getdata();
		},
		methods: {
			getdata() {
				let id = this.$route.query.id;
				let _this = this;
				_this.$api.user.getCxmkInfo({
					id: id,
				}).then(res => {
					if (res.code == 1) {
						_this.detail = res.data;
					}
				})
			},
		},

	}
</script>
<style scoped>
	.content {
		background-color: #1452DC;
		border-bottom: 1px solid #1452DC;
		/* overflow: hidden; */
	}
</style>
<style scoped lang="scss">
	.left {
		align-self: flex-start;
		position: sticky;
		top: 100px;

		.leftD {
			background-color: #fff;
			border-radius: 20px;
			padding: 14px 30px 6px;
			width: 8vw;
			align-self: flex-start;
			z-index: 100;
			background-color: rgba(207, 232, 252, 0.5);
			margin-right: 20px;

			.leftD_child {
				margin: 20px 0;
				padding-bottom: 10px;
				font-size: 16px;
				text-align: center;
				color: #333;
				border-bottom: 1px solid #fff;
			}

			.leftD_child:last-child {
				border: none;
			}

			.leftD_child:hover {
				cursor: pointer;
				color: #1452DC;
				animation: changeTab .2s linear forwards;
			}
		}
	}

	.right {
		flex-grow: 1;
	}

	.swiperImg {
		background-image: url('../../assets/page4/bg1.png');
		background-size: cover;
		background-position: center;
		position: relative;
		padding: 250px 0;

		.lTitle {
			margin-left: 4vw;
			font-size: 30px;
			letter-spacing: 4px;
			color: #fff;
		}

		.bTitle {
			margin-left: 4vw;
			color: #fff;
			font-size: 58px;
			letter-spacing: 4px;
			font-weight: bold;
		}

		.sTitle {
			margin-left: 4vw;
			letter-spacing: 2px;
			font-size: 14px;
			color: #fff;
		}
	}

	.center {
		min-height: 300px;
		margin: 0 auto 100px;
		background-color: #fff;
		// padding: 70px 190px;
		padding: 80px 120px;
		border-radius: 30px;
		position: relative;
		top: -80px;
	}
</style>


// WEBPACK FOOTER //
// searchXmdetail.vue?429f1808